// extracted by mini-css-extract-plugin
export default {"popup":"style_popup__WPn0V","content":"style_content__nYmds"};